<template>
  <!--  毛玻璃布局-->
  <div class="box">
<!--    <div style="float: left">-->
<!--      <img v-if="getHidden('right')" class="box-lr" src="../../assets/images/box-right.png" style="right: 0;">-->
<!--      <img v-if="getHidden('left')" class="box-lr" src="../../assets/images/box-left.png">-->
<!--      <img v-if="getHidden('top')" class="box-tb" src="../../assets/images/box-top.png" style="top: 0;">-->
<!--      <img v-if="getHidden('bottom')" class="box-tb" src="../../assets/images/box-bottom.png" style="bottom: 0;">-->
<!--    </div>-->
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: "CloudedGlass",
  props: {
    hiddenArray: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getHidden(location) {
      return this.hiddenArray.indexOf(location) === -1
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.box {
  position: relative;
  border-radius: 4px;
  box-shadow:
    -0.1px 0 30px 0 rgba(41, 155, 255, .1) inset,
    -0.5px 0 30px 0 rgba(41, 155, 255, 0.08) inset,
    -1px 0 30px 0 rgba(41, 155, 255, 0.05) inset,
    -1.5px 0 30px 0 rgba(41, 155, 255, 0.01) inset;
}

.box-lr {
  width: 20px;
  height: 100%;
  position: absolute;
}

.box-tb {
  position: absolute;
  left: 0;
  width: 100%;
  height: 20px;
}
</style>
